import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomToastContainer from '../components/CustomToastContainer';
import { toast } from 'react-toastify';
import { faCopy } from '@fortawesome/free-regular-svg-icons';

const PaymentAccountInfoCard = ({ account }) => {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.info("Text Copied: " + text);
    });
  };
  const [bank, branch] = account.bank_branch.split("-");

  return (
    <>
        <div className="w-full bg-gray-200 pt-3 pl-3 pr-3" >
            <div className="bg-white p-4 m-2 rounded-lg shadow-lg cursor-pointer md:px-8">
                <h1 className="text-lg md:text-xl font-bold text-center text-gray-800 mb-4 ">
                    {bank}
                </h1>
                <div className="flex items-center mb-2">
                    <span className="text-sm md:text-lg font-bold text-gray-800">Branch:</span>
                    <span className="ml-2 text-sm md:text-lg text-gray-800">{branch}</span>
                </div>
                <div className="flex items-center mb-2">
                    <span className="text-sm md:text-lg font-bold text-gray-800">Title:</span>
                    <span className="ml-2 text-sm md:text-lg text-gray-800">
                        {account.account_title}
                    </span>
                </div>
                <div className="flex items-center mb-2">
                    <span className="text-sm md:text-lg font-bold text-gray-800">Acc No:</span>
                    <span className="ml-2 text-sm md:text-lg text-gray-800">
                        {account.account_number}
                    </span>
                    <button
                        className="ml-auto text-red-500"
                        onClick={(e) => {
                            e.stopPropagation(); 
                            copyToClipboard(account.account_number);
                        }}
                    >
                        <FontAwesomeIcon icon={faCopy} className="w-5 h-5 md:w-6 md:h-6 text-red-500" />
                    </button>
                </div>
                <div className="flex items-center mb-2 ">
                    <span className="text-sm md:text-lg font-bold text-gray-800">IBAN:</span>
                    <span className="ml-2 text-sm md:text-lg text-gray-800">{account.iban}</span>
                    <button
                        className="ml-auto text-red-500 "
                        onClick={(e) => {
                        e.stopPropagation();
                        copyToClipboard(account.iban);
                        }}
                    >
                        <FontAwesomeIcon icon={faCopy} className="w-5 h-5 md:w-6 md:h-6 text-red-500"/>
                    </button>
                </div>
                {account.note && (
                <div className="text-sm text-gray-800 text-center pt-2">
                    *{account.note}
                </div>
                )}
            </div>
        </div>
        <CustomToastContainer/>
    </>
  );
};

export default PaymentAccountInfoCard;
